import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { MediaData } from "./media";
import { RFSData } from "./rfs";

interface OPMPoleData {
  id: string;
  poleId: string;
  poleIdStatus: boolean;
  isValid: boolean;
  imagePoleId: string;
  imagePoleIdMedia?: MediaData;
  rfs: RFSData;
  createdDate: string;
  updatedDate: string | null;
}

interface OPMFDTQueryKey {
  rfsId: string;
}

async function getPoles(
  queryFunctionContext: QueryFunctionContext,
): Promise<OPMPoleData[]> {
  const { queryKey } = queryFunctionContext;
  const [_, opmFDTQueryKey] = queryKey;
  const { rfsId } = opmFDTQueryKey as OPMFDTQueryKey;

  const response = await axiosInstance.get(
    "/api/crud/opm-pole" + `?rfs.id=${rfsId ?? ""}`,
  );
  return response.data.data.content;
}
function usePoles(opmFDTQueryKey: OPMFDTQueryKey) {
  const { rfsId } = opmFDTQueryKey;
  return useQuery({
    queryKey: ["opmPoles", { rfsId }],
    queryFn: getPoles,
  });
}

export type { OPMPoleData };
export { usePoles };
